import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 1.5rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.gray01};
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
`;

export const Player = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Stage = styled.div`
  position: relative;
  width: 100%;
  min-height: 10rem;
`;

export const LoadingBox = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.backgroundColor};
`;

export const LoadingText = styled.span`
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const Wave = styled.div<{ $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  align-items: center;
  width: 100%;
  height: 10rem;
  overflow: hidden;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.backgroundColor};
  cursor: pointer;
  box-sizing: border-box;

  & > div {
    width: 100%;
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const PlayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 3.5rem;
  height: 3.5rem;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme }) => theme.colors?.primary};
  color: ${({ theme }) => theme.colors?.text?.tertiary};

  svg {
    font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs32};
  }
`;

export const Time = styled.span`
  min-width: 7.5rem;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const Range = styled.input`
  width: 6rem;
  accent-color: ${({ theme }) => theme.colors?.primary};
`;

export const Select = styled.select`
  padding: 0.35rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors?.gray03};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors?.backgroundColor};
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const HiddenAudio = styled.audio`
  display: none;
`;

export const NativeAudio = styled.audio`
  width: 100%;
`;

export const SoundCloudFrame = styled.iframe<{ $visible?: boolean }>`
  width: 100%;
  min-height: ${({ $visible }) => ($visible === false ? '0' : '450px')};
  height: ${({ $visible }) => ($visible === false ? '0' : '450px')};
  border: none;
  border-radius: 10px;
  visibility: ${({ $visible }) => ($visible === false ? 'hidden' : 'visible')};
  position: ${({ $visible }) => ($visible === false ? 'absolute' : 'static')};
`;
